export enum TeamEventTypes {
  training = 1,
  other = 2,
}
